import { request as httpRequest } from './http-library.js';
import publicConfig from '../public-config.js';

const ssoHost = publicConfig.external_address;

export const Listings = {
  read: function readListing (path, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/listings/${path}`,
      method: 'GET'
    };
    httpRequest(requestParams, function request (response) {
      callback(response);
    });
  },

  update: function updateListing (query, token, payload, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/listings/${query}`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpRequest(requestParams, function listingUpdateCB (response) {
      callback(response);
    }, payload);
  },

  updateV2: function updateListing (query, token, payload, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v2/spaces-v2/listings/${query}`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    httpRequest(requestParams, function listingUpdateCB (response) {
      callback(response);
    }, payload);
  },

  searchByIDs: function searchByIDs (listings, callback) {
    const listingsString = listings.join('&id=');
    const requestParams = {
      host: ssoHost,
      path: `/v1/search/listings?id=${listingsString}`,
      method: 'GET'
    };

    httpRequest(requestParams, function request (response) {
      callback(response);
    }, null);
  },

  readBySpaceID: function readBySpaceID (parentSpaceID, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/listings?parent_space_id=${parentSpaceID}`,
      method: 'GET'
    };

    httpRequest(requestParams, function request (response) {
      callback(response);
    }, null);
  },

  queryListings: function queryListings (query, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/listings/${query}`,
      method: 'GET'
    };
    httpRequest(requestParams, function request (response) {
      callback(response);
    }, null);
  }
};
